export default "__VITE_ASSET__onxO5KeK__"